import { gql } from "@apollo/client";

export const USER_REGISTER_MUTATION = gql`
  mutation ($password: String!, $emailAddress: String!, $title: String, $firstName: String, $lastName: String, $phoneNumber: String) {
    registerCustomerAccount(
      input:
        {password: $password, emailAddress: $emailAddress, title: $title,  firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber}
       )
      {
      ... on Success {
        success
      }
      ... on MissingPasswordError {
        errorCode
        message
      }
      ... on PasswordValidationError {
        errorCode
        message
        validationErrorMessage
      }
      ... on NativeAuthStrategyError {
        errorCode
        message
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
`;
